import ActionCable from 'actioncable';

export const cable = ActionCable.createConsumer(
  `ws${window.location.protocol === 'https:' ? 's' : ''}://${window.location.hostname}${
    window.location.port ? ':' + window.location.port : ''
  }/cable`
);
